//
//
//

import Approval from './approval.vue';
export default {
  name: 'FlowNode',
  components: {
    Approval: Approval
  },
  data: function data() {
    return {
      sourceData: {
        nodeName: this.$t('work_rule_39'),
        type: 9,
        warning: {
          status: true,
          msg: ''
        },
        form: {}
      }
    };
  }
};